export default {
  /**
   * Format user's full name based on object from API response
   * @param {Object} user user data
   * @returns full name
   */
  formatUserName(user=null) {
    if ( !(typeof user === 'object') ) return;
    if (user.name) return user.name;
    
    let name = '';
    if (user.first_name) name += this.warranty.user.first_name;
    if (user.last_name) name += " " + this.warranty.user.last_name;
    return name;
  }
};
